<!-- @format -->

<template>
	<CoreTwoColumnsRow>
		<template #left>
			<CoreBorderWrapper
				:condensed="true"
				class="flex-grow-1 flex-shrink-1 flex-basis-55 flex space-between"
			>
				<div class="flex-1 text-bold">
					{{ $t('§eq_type.buy_back_option') }}
				</div>
				<CoreIcon
					name="information-outline"
					size="18"
					class="ml-auto"
					fillColor="var(--color-secondary-200)"
					v-tooltip="{ value: $t('§eq_type.buy_back_option_tooltip') }"
				/>
			</CoreBorderWrapper>
		</template>
		<template #right>
			<CoreBorderWrapper
				:condensed="true"
				:noBorder="true"
				class="flex-grow-1 flex-shrink-1 flex-basis-45 flex justify-center"
			>
				<CoreSelectButton
					name="buy_back"
					:options="buyBackOptions"
					:condensed="true"
					v-model="unitTypeStore.unitTypeData.buy_back"
				/>
			</CoreBorderWrapper>
		</template>
	</CoreTwoColumnsRow>
</template>

<script>
import { useUnitTypeStore } from '@/stores/unitType'
import CoreTwoColumnsRow from '@/components/core/CoreTwoColumnsRow.vue'
import CoreBorderWrapper from '@/components/core/CoreBorderWrapper.vue'
import CoreSelectButton from '@/components/core/CoreSelectButton.vue'
import CoreIcon from '@/components/core/CoreIcon.vue'

export default {
	name: 'InputsBuyBackOption',

	components: {
		CoreBorderWrapper,
		CoreTwoColumnsRow,
		CoreSelectButton,
		CoreIcon,
	},

	data() {
		return {
			unitTypeStore: useUnitTypeStore(),
		}
	},

	computed: {
		buyBackOptions() {
			return [
				{ value: 1, label: this.$t('§ui_button.yes') },
				{ value: 0, label: this.$t('§ui_button.no') },
			]
		},
	},

	watch: {
		'unitTypeStore.unitTypeData.buy_back'(newValue) {
			if (!newValue) {
				this.unitTypeStore.clearResidualValues()
			}
		},
	},
}
</script>
